// extracted by mini-css-extract-plugin
export var copyIcon = "_sj-2";
export var discountCard = "_sj-0";
export var discountCode = "_sj-3";
export var discountContent = "_sj-1";
export var loadingCard = "_sj-4";